var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-toggle"},[_c('div',{staticClass:"player-potion-bkgd",class:[
            { 'toggled-off': !_vm.toggled, 'toggled-on': _vm.toggled },
            `potion_${_vm.potion}_toggle`,
        ],on:{"click":function($event){return _vm.updatePotionState(_vm.potion, _vm.toggled)}}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }